import { Divider as CascadiaDivider } from "@certn/cascadia-react";
import { ControlProps } from "@jsonforms/core";
import { withJsonFormsControlProps } from "@jsonforms/react";
import React from "react";

export function Divider(props: ControlProps) {
  return <CascadiaDivider />;
}

export const DividerRenderer = withJsonFormsControlProps(Divider);
